import { useEffect } from "react";
import "./CopilotWidget.scss";

const WIDGET_SRC = "https://hey-api-4w49.onrender.com/api/widget.js";
const SCRIPT_ID = "copilot-chat-widget";

/**
 * Loads the Copilot chat bubble. Key comes from
 * REACT_APP_COPILOT_API_KEY in frontend/.env (restart yarn start after changing).
 */
export default function CopilotWidget() {
  useEffect(() => {
    const apiKey =
      process.env.REACT_APP_COPILOT_API_KEY ||
      "sk_1a97b5d88fa741b992cc21f53d239b94";
    if (!apiKey) {
      // eslint-disable-next-line no-console
      console.warn(
        "[Copilot] Missing REACT_APP_COPILOT_API_KEY in frontend/.env — widget not loaded.",
      );
      return undefined;
    }

    // eslint-disable-next-line no-console
    console.info("[Copilot] init with key", `${apiKey.slice(0, 10)}…`);

    const stale = document.getElementById(SCRIPT_ID);
    if (stale) stale.remove();

    window.SiteChat = "chat";
    window.chat = function chatStub() {
      (window.chat.q = window.chat.q || []).push(arguments);
    };
    window.chat.q = [];

    window.chat("init", { apiKey });

    const js = document.createElement("script");
    js.id = SCRIPT_ID;
    js.async = true;
    js.src = WIDGET_SRC;
    js.onload = () => {
      // eslint-disable-next-line no-console
      console.info("[Copilot] widget.js loaded from", WIDGET_SRC);
    };
    js.onerror = () => {
      // eslint-disable-next-line no-console
      console.error(
        "[Copilot] Failed to load widget.js — check Network tab for",
        WIDGET_SRC,
      );
    };
    document.body.appendChild(js);

    return undefined;
  }, []);

  return null;
}
